export class Filter {
    category: string
    subCategory: string[]
    isCollapsed: boolean

    constructor (category: string, subCategory: string[]){
        this.category = category;
        this.subCategory = subCategory;
    }
}